import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { DynamicDialogService } from 'src/app/dynamic-dialog/dynamic-dialog.service';
import { MotorService } from 'src/app/fleet/motor/motor.service';
import { FeatureFlagEnum } from 'src/app/shared/feature-flags.enum';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { SpaRoutingService } from 'src/app/shared/services/spa.routing.service';
import { ThirdPartyApp } from './links-registry';

@Injectable({ providedIn: 'root' })
export class ThirdPartyAppLauncherService {

    constructor(
        private readonly spaRoutingService: SpaRoutingService,
        private readonly motor: MotorService,
        private readonly featureFlagService: FeatureFlagService,
        private readonly dialogService: DynamicDialogService) { }

    launch(app: ThirdPartyApp): void {
        switch (app.launch.kind) {
            case 'route':
                this.spaRoutingService.navigateToTenantPath(app.launch.path);
                return;
            case 'motorSso':
                this.launchFleetCross();
                return;
        }
    }

    // Same new-tab/dialog split the in-screen FleetCross buttons use, minus their vehicle/part context.
    private launchFleetCross(): void {
        combineLatest([
            this.motor.getUrl(),
            this.featureFlagService.getFeatureFlagValue(FeatureFlagEnum.MotorNewTab).pipe(take(1))
        ]).pipe(take(1))
            .subscribe(([res, shouldOpenInNewTab]) => {
                if (shouldOpenInNewTab) {
                    window.open(res.url, '_blank');
                    return;
                }
                this.dialogService.openFleetCrossDialog(res.url);
            });
    }
}
